module.exports = __webpack_public_path__ + "img/actions.737d933f.png";